(function webpackUniversalModuleDefinition(root, factory) {
  if (typeof exports === 'object' && typeof module === 'object') module.exports = factory(require("react"), require("classnames"), require("@material/notched-outline/dist/mdc.notchedOutline.js"));else if (typeof define === 'function' && define.amd) define(["react", "classnames", "@material/notched-outline/dist/mdc.notchedOutline.js"], factory);else {
    var a = typeof exports === 'object' ? factory(require("react"), require("classnames"), require("@material/notched-outline/dist/mdc.notchedOutline.js")) : factory(root["react"], root["classnames"], root["@material/notched-outline/dist/mdc.notchedOutline.js"]);

    for (var i in a) {
      (typeof exports === 'object' ? exports : root)[i] = a[i];
    }
  }
})(typeof self !== 'undefined' ? self : this, function (__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_56__) {
  return (
    /******/
    function (modules) {
      // webpackBootstrap

      /******/
      // The module cache

      /******/
      var installedModules = {};
      /******/

      /******/
      // The require function

      /******/

      function __webpack_require__(moduleId) {
        /******/

        /******/
        // Check if module is in cache

        /******/
        if (installedModules[moduleId]) {
          /******/
          return installedModules[moduleId].exports;
          /******/
        }
        /******/
        // Create a new module (and put it into the cache)

        /******/


        var module = installedModules[moduleId] = {
          /******/
          i: moduleId,

          /******/
          l: false,

          /******/
          exports: {}
          /******/

        };
        /******/

        /******/
        // Execute the module function

        /******/

        modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
        /******/

        /******/
        // Flag the module as loaded

        /******/

        module.l = true;
        /******/

        /******/
        // Return the exports of the module

        /******/

        return module.exports;
        /******/
      }
      /******/

      /******/

      /******/
      // expose the modules object (__webpack_modules__)

      /******/


      __webpack_require__.m = modules;
      /******/

      /******/
      // expose the module cache

      /******/

      __webpack_require__.c = installedModules;
      /******/

      /******/
      // define getter function for harmony exports

      /******/

      __webpack_require__.d = function (exports, name, getter) {
        /******/
        if (!__webpack_require__.o(exports, name)) {
          /******/
          Object.defineProperty(exports, name, {
            /******/
            configurable: false,

            /******/
            enumerable: true,

            /******/
            get: getter
            /******/

          });
          /******/
        }
        /******/

      };
      /******/

      /******/
      // getDefaultExport function for compatibility with non-harmony modules

      /******/


      __webpack_require__.n = function (module) {
        /******/
        var getter = module && module.__esModule ?
        /******/
        function getDefault() {
          return module['default'];
        } :
        /******/
        function getModuleExports() {
          return module;
        };
        /******/

        __webpack_require__.d(getter, 'a', getter);
        /******/


        return getter;
        /******/
      };
      /******/

      /******/
      // Object.prototype.hasOwnProperty.call

      /******/


      __webpack_require__.o = function (object, property) {
        return Object.prototype.hasOwnProperty.call(object, property);
      };
      /******/

      /******/
      // __webpack_public_path__

      /******/


      __webpack_require__.p = "";
      /******/

      /******/
      // Load entry module and return exports

      /******/

      return __webpack_require__(__webpack_require__.s = 55);
      /******/
    }(
    /************************************************************************/

    /******/
    {
      /***/
      0:
      /***/
      function _(module, exports) {
        module.exports = __WEBPACK_EXTERNAL_MODULE_0__;
        /***/
      },

      /***/
      1:
      /***/
      function _(module, exports) {
        module.exports = __WEBPACK_EXTERNAL_MODULE_1__;
        /***/
      },

      /***/
      55:
      /***/
      function _(module, exports, __webpack_require__) {
        "use strict";

        var __extends = this && this.__extends || function () {
          var _extendStatics = function extendStatics(d, b) {
            _extendStatics = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (d, b) {
              d.__proto__ = b;
            } || function (d, b) {
              for (var p in b) {
                if (b.hasOwnProperty(p)) d[p] = b[p];
              }
            };

            return _extendStatics(d, b);
          };

          return function (d, b) {
            _extendStatics(d, b);

            function __() {
              this.constructor = d;
            }

            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
          };
        }();

        Object.defineProperty(exports, "__esModule", {
          value: true
        }); // The MIT License
        //
        // Copyright (c) 2018 Google, Inc.
        //
        // Permission is hereby granted, free of charge, to any person obtaining a copy
        // of this software and associated documentation files (the "Software"), to deal
        // in the Software without restriction, including without limitation the rights
        // to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
        // copies of the Software, and to permit persons to whom the Software is
        // furnished to do so, subject to the following conditions:
        //
        // The above copyright notice and this permission notice shall be included in
        // all copies or substantial portions of the Software.
        //
        // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
        // IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
        // FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
        // AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
        // LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
        // OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
        // THE SOFTWARE.

        var React = __webpack_require__(0);

        var classnames = __webpack_require__(1); // @ts-ignore no .d.ts file


        var mdc_notchedOutline_1 = __webpack_require__(56);

        ;
        ;

        var NotchedOutline =
        /** @class */
        function (_super) {
          __extends(NotchedOutline, _super);

          function NotchedOutline() {
            var _this = _super !== null && _super.apply(this, arguments) || this;

            _this.outlineElement_ = React.createRef();
            _this.pathElement_ = React.createRef();
            _this.idleElement_ = React.createRef();
            _this.state = {
              classList: new Set()
            };
            return _this;
          }

          NotchedOutline.prototype.componentDidMount = function () {
            this.foundation_ = new mdc_notchedOutline_1.MDCNotchedOutlineFoundation(this.adapter);
            this.foundation_.init();
            var _a = this.props,
                notch = _a.notch,
                notchWidth = _a.notchWidth,
                isRtl = _a.isRtl;

            if (notch) {
              this.foundation_.notch(notchWidth, isRtl);
            }
          };

          NotchedOutline.prototype.componentWillUnmount = function () {
            this.foundation_.destroy();
          };

          NotchedOutline.prototype.componentDidUpdate = function (prevProps) {
            var hasToggledNotch = this.props.notch !== prevProps.notch;
            var hasToggleRtl = this.props.isRtl !== prevProps.isRtl;
            var notchWidthUpdated = this.props.notchWidth !== prevProps.notchWidth;
            var shouldUpdateNotch = notchWidthUpdated || hasToggleRtl || hasToggledNotch;

            if (!shouldUpdateNotch) {
              return;
            }

            if (this.props.notch) {
              var _a = this.props,
                  notchWidth = _a.notchWidth,
                  isRtl = _a.isRtl;
              this.foundation_.notch(notchWidth, isRtl);
            } else {
              this.foundation_.closeNotch();
            }
          };

          Object.defineProperty(NotchedOutline.prototype, "classes", {
            get: function get() {
              var classList = this.state.classList;
              var className = this.props.className;
              return classnames('mdc-notched-outline', Array.from(classList), className);
            },
            enumerable: true,
            configurable: true
          });
          Object.defineProperty(NotchedOutline.prototype, "adapter", {
            get: function get() {
              var _this = this;

              return {
                getWidth: function getWidth() {
                  return _this.outlineElement_.current ? _this.outlineElement_.current.offsetWidth : 0;
                },
                getHeight: function getHeight() {
                  return _this.outlineElement_.current ? _this.outlineElement_.current.offsetHeight : 0;
                },
                addClass: function addClass(className) {
                  return _this.setState({
                    classList: _this.state.classList.add(className)
                  });
                },
                removeClass: function removeClass(className) {
                  var classList = _this.state.classList;
                  classList.delete(className);

                  _this.setState({
                    classList: classList
                  });
                },
                setOutlinePathAttr: function setOutlinePathAttr(value) {
                  if (_this.pathElement_.current) {
                    _this.pathElement_.current.setAttribute('d', value);
                  }
                },
                getIdleOutlineStyleValue: function getIdleOutlineStyleValue(propertyName) {
                  if (!_this.idleElement_.current) return;
                  return window.getComputedStyle(_this.idleElement_.current).getPropertyValue(propertyName);
                }
              };
            },
            enumerable: true,
            configurable: true
          });

          NotchedOutline.prototype.render = function () {
            return React.createElement(React.Fragment, null, React.createElement("div", {
              className: this.classes,
              key: 'notched-outline',
              ref: this.outlineElement_
            }, React.createElement("svg", {
              focusable: 'false'
            }, React.createElement("path", {
              ref: this.pathElement_,
              className: 'mdc-notched-outline__path'
            }))), React.createElement("div", {
              ref: this.idleElement_,
              className: 'mdc-notched-outline__idle',
              key: 'notched-outline-idle'
            }));
          };

          NotchedOutline.defaultProps = {
            className: '',
            isRtl: false,
            notch: false,
            notchWidth: 0
          };
          return NotchedOutline;
        }(React.Component);

        exports.default = NotchedOutline;
        /***/
      },

      /***/
      56:
      /***/
      function _(module, exports) {
        module.exports = __WEBPACK_EXTERNAL_MODULE_56__;
        /***/
      }
      /******/

    })
  );
});